export default "__VITE_ASSET__DYZXmsES__"